/* Cart drawer mobile/desktop layout fix — v2.
   Inject style into the shadowRoot of <cart-drawer> so that:
   - The product list area takes the space it needs (no forced empty gap)
   - The footer (notes/discount/totals/protection/gift extras) is capped to ~50% of
     viewport and scrolls internally instead of pushing content off-screen.
*/
(function(){
  'use strict';
  var STYLE_ID = 'oh-cart-shadow-fix';
  var CSS = (
    /* The shadow layout is: outer fixed > inner fixed > flex column { header, content, footer } */
    'div:nth-child(2) > header { flex-shrink: 0 !important; }' +
    /* Content area: products list — natural height, scrolls if many products */
    'div:nth-child(2) > div:not(header):not(footer) {' +
      'flex: 0 1 auto !important;' +
      'min-height: 0 !important;' +
      'overflow-y: auto !important;' +
    '}' +
    /* Footer: cap at half the viewport, scroll internally if extras pile up */
    'footer {' +
      'max-height: 60vh !important;' +
      'overflow-y: auto !important;' +
      'flex: 0 1 auto !important;' +
    '}'
  );

  function inject(el){
    try{
      var r = el.shadowRoot;
      if (!r || r.getElementById(STYLE_ID)) return;
      var s = document.createElement('style');
      s.id = STYLE_ID;
      s.textContent = el.classList.contains('og-cart-refined') ? '[part=header]{flex-shrink:0!important;}[part=body]{flex:1 1 auto!important;min-height:0!important;overflow-y:auto!important;}[part=footer]{flex:0 0 auto!important;max-height:50vh!important;max-height:50svh!important;overflow-y:auto!important;}' : CSS;
      r.appendChild(s);
    }catch(e){}
  }
  function applyAll(){
    var nodes = document.querySelectorAll('cart-drawer');
    for (var i = 0; i < nodes.length; i++) inject(nodes[i]);
  }
  function onReady(){
    applyAll();
    var obs = new MutationObserver(function(ms){
      for (var i = 0; i < ms.length; i++){
        var a = ms[i].addedNodes;
        for (var j = 0; j < a.length; j++){
          var n = a[j];
          if (n && n.nodeType === 1){
            if (n.tagName === 'CART-DRAWER') inject(n);
            else if (n.querySelectorAll){
              var inner = n.querySelectorAll('cart-drawer');
              for (var k = 0; k < inner.length; k++) inject(inner[k]);
            }
          }
        }
      }
    });
    obs.observe(document.documentElement, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', onReady);
  else onReady();
  document.addEventListener('cart:open', applyAll);
  document.addEventListener('shopify:section:load', applyAll);
})();
